import isNaN from "lodash/isNaN";
import { Alert } from "PFComponents/alert";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BookingFormValues } from "../booking_form_provider";

export const BookingFormErrorMessage = () => {
  const { t } = useTranslation("bookingModule");

  const {
    formState: { errors }
  } = useFormContext<BookingFormValues>();
  const numberOfBookings = useWatch<BookingFormValues, "bookings", unknown, number>({
    name: "bookings",
    compute: (bookings) => bookings?.length ?? 0
  });

  const bookingsIndexesWithErrors = Object.keys(errors.bookings || [])
    .map(Number)
    .filter((index) => !isNaN(index) && !!errors.bookings?.[index])
    .map((index) => index + 1)
    .sort((prev, next) => prev - next);

  if (bookingsIndexesWithErrors.length === 0 || numberOfBookings < 2) {
    return null;
  }

  const errorMessage =
    bookingsIndexesWithErrors.length > 1
      ? t("bookings.bookingMultipleErrorMessage", {
          bookings: bookingsIndexesWithErrors.slice(0, -1).join(", "),
          lastBooking: bookingsIndexesWithErrors.slice(-1)
        })
      : t("bookings.bookingSingleErrorMessage", { bookingNumber: bookingsIndexesWithErrors[0] });

  return <Alert kind="error" title={errorMessage} icon="error" />;
};
